import * as React from "react";
import { Icon } from "../Icon/icon";
import { KeyboardEventKeys } from "../../utils/keyboardEventKeys";
import { EpiserverProperty } from "../../utils/episerver.property";
import { setInnerHtml } from "../../utils/helpers";

interface ITooltipProps {
  text: string;
  enableEpiserverOnPageEditing?: boolean;
  isInEditMode?: boolean;
  editableEpiserverPropertyName?: string;
  textInsteadOfSvg?: string;
}
interface ITooltipState {
  isOpen: boolean;
}

/**
 * A tooltip icon (!) that shows a help text on click.
 * _The tooltip can only be closed by pressing the X button or ESC key. Pressing outside the tooltip area won't close it by design. Clicking on the icon itself will toggle the tooltip._
 */
export class Tooltip extends React.Component<ITooltipProps, ITooltipState> {
  constructor(props: ITooltipProps) {
    super(props);
    this.state = { isOpen: false };
  }

  componentDidMount() {
    document.addEventListener("keyup", (e) => {
      if (this.state.isOpen && e.key === KeyboardEventKeys.esc) {
        e.preventDefault();
        this.setState({ isOpen: false });
      }
    });
  }

  toggleTooltip = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  closeTooltip = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    this.setState({ isOpen: false });
  };

  closeTooltipWithBackDrop = (): void => {
    this.setState({ isOpen: false });
  };

  render(): JSX.Element {
    const {
      text,
      isInEditMode,
      enableEpiserverOnPageEditing,
      editableEpiserverPropertyName,
    } = this.props;

    return (
      <div className="tooltip">
        <button
          type="button"
          onClick={this.toggleTooltip}
          className="tooltip__button"
          aria-label="Ytterligare information"
        >
          {this.props.textInsteadOfSvg ? (
            this.props.textInsteadOfSvg
          ) : (
            <Icon
              iconType="Infocirkel_normal20px20px"
              isAriaHidden={false}
              ariaLabel="Mera information"
            />
          )}
        </button>
        <div
          className={`tooltip__bubble drop-shadow-high-elevation ${
            this.state.isOpen ? "open" : ""
          }`}
        >
          {this.state.isOpen && (
            <>
              <div role="alert">
                {!enableEpiserverOnPageEditing && <>{text}</>}
                {enableEpiserverOnPageEditing && (
                  <EpiserverProperty
                    isInEditMode={isInEditMode}
                    propertyName={editableEpiserverPropertyName}
                    usingDangerouslySetInnerHTML={true}
                  >
                    <div dangerouslySetInnerHTML={setInnerHtml(text)} />
                  </EpiserverProperty>
                )}
              </div>
              <button
                type="button"
                onClick={this.closeTooltip}
                className="tooltip__button tooltip__close"
                aria-label="Stäng ytterligare infomation"
              >
                <Icon iconType="ic_close_white_24px" />
              </button>
            </>
          )}
        </div>
        <div
          className={`backdrop ${this.state.isOpen ? "open" : ""}`}
          onClick={this.closeTooltipWithBackDrop}
        ></div>
      </div>
    );
  }
}
